import {
  Component,
  ElementRef,
  OnInit,
  Renderer2,
  RendererStyleFlags2,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

import { NavLink } from '@models/navlink.model';
import { UserProfileService } from '@services/user-profile.service';
import { AuthService } from '../../../../../core/auth/auth.service';
import { MenuPartner } from './const/partner-menu-config';
import { ProfileType } from '@variables/profileType';
import {MainMenuBackofficeService} from '@modules/backoffice/main-menu-backoffice/main-menu-backoffice.service';
import {firstValueFrom} from 'rxjs';

@Component({
    selector: 'app-menu-nav',
    templateUrl: './menu-nav.component.html',
    styleUrls: ['./menu-nav.component.scss'],
    standalone: false
})
export class MenuNavComponent implements OnInit {
  menuLinks: NavLink[] = [];

  isMainMenuBackoffice = false;

  mainMenuBackofficePath: string;
  profileRootPath: string;

  urlActive: string;
  menuActive: NavLink;
  menuSubitemsActive: string;
  private pathActive: string;
  private rolesUser: Set<string> = new Set<string>();

  protected userProfile: number;
  readonly profileType = ProfileType;

  constructor(
    private _router: Router,
    private authService: AuthService,
    private _elRef: ElementRef,
    private _renderer: Renderer2,
    private _userProfileService: UserProfileService,
    private mainMenuBackofficeService: MainMenuBackofficeService
  ) { }

  async ngOnInit(): Promise<void> {
    this.rolesUser = await firstValueFrom(this.authService._getUserRoles());
    this.setInitialMenuConfig();

    this.setMenuNavActiveFromUrl(this.urlActive);

    this._router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        const url = event.urlAfterRedirects;
        this.pathActive = url;
        this.setMenuNavActiveFromUrl(url);
      }
    });
  }

  private setInitialMenuConfig() {
    this.userProfile = this._userProfileService.getUserProfile();

    switch (this.userProfile) {
      case ProfileType.BACKOFFICE:
        this.menuLinks = this.mainMenuBackofficeService.loadDynamicMenuByUserPermission(Array.from(this.rolesUser));
        this.profileRootPath = '/backoffice/';
        this.mainMenuBackofficePath = '/backoffice/menu-inicial';
        break;
      case ProfileType.PARTNER:
        this.menuLinks = MenuPartner;
        this.profileRootPath = '/parceiro/';
        this.mainMenuBackofficePath = '';
        break;
      default:
        this.menuLinks = [];
        this.profileRootPath = '';
        this.mainMenuBackofficePath = '';
        break;
    }

    this.urlActive = this._router.routerState.snapshot.url;
    this.pathActive = this.urlActive;
  }

  protected hasMultipleProfile(): boolean {
    return this._userProfileService.hasMultipleProfile();
  }

  setMenuNavActiveFromUrl(url: string) {
    const paths = url.split('/');
    let menuPath: string;

    if (paths[2] === 'menu-inicial') {
      this.isMainMenuBackoffice = true;
      menuPath = paths[3];
      return;
    }

    if (paths[1] === 'parceiro') {
      this.isMainMenuBackoffice = false;
      menuPath = paths[1];
    } else if (paths[1] === 'backoffice') {
      this.isMainMenuBackoffice = false;
      menuPath = paths[2];
    }

    this.menuLinks.forEach((menu) => {
      if (menu.path === menuPath) {
        this.menuActive = menu;
      }
    });
  }


  isMenuActivePath(itemPath: string, isBackofficeMenu: boolean, item?: NavLink): boolean {
    if (this.pathActive.includes(itemPath)) {
      return true;
    } else if (isBackofficeMenu && item?.path === undefined) {
      let isPath = false;

      // Ativa o menu se o submenu corresponde à URL ativa

      if (Array.isArray(item.children)) {
        item.children.forEach((child) => {
          if (this.pathActive.includes(child.path)) {
            isPath = true;
          }
        });
      }

      return isPath;
    }
    return false;
  }

  logout() {
    this.authService.logOut();
  }

  openMenuSubitems(menu: string) {
    this.menuSubitemsActive = menu;
  }

  generateClassName(item: NavLink): string {
    return item.params?.toLowerCase().replace(/\s/g, '').substring(0, 4).toString();
  }

  // Manipulates DOM elements to open the submenu below the corresponding menu button
  handleClassByMenusIds(item: NavLink) {
    const menuDiv = this.getDivMenuById(item);

    if (menuDiv) {
      const submenuDiv = this.getDivSubmenuByClass(item);

      if (submenuDiv) {
        this.rendererClassSubmenu(menuDiv, submenuDiv);
      }
    }
    return undefined;
  }

  private getDivMenuById(item: NavLink): any {
    const idMenu =
      '#menu-links-' + item.params.toLowerCase().trim().substring(0, 4);
    return this._elRef.nativeElement.querySelector(idMenu);
  }

  private getDivSubmenuByClass(item: NavLink): Element {
    const classSubmenu =
      '.submenu-' + item.params.toLowerCase().trim().substring(0, 4);
    return document.querySelector(classSubmenu);
  }

  private rendererClassSubmenu(menu: any, submenu: Element) {
    this._renderer.setStyle(
      submenu,
      'top',
      '88px',
      RendererStyleFlags2.Important,
    );
    this._renderer.setStyle(
      submenu,
      'left',
      `${menu.offsetLeft}px`,
      RendererStyleFlags2.Important,
    );
  }

  changeProfile() {
    this._router.navigateByUrl('/selecionar-perfil');
  }
}
